/**
 * @file
 * The undo toast (berTags.undo): a timed chance to take an action back.
 * A thin convenience wrapper over the shared toast stack (berTags.toast).
 */

((Drupal) => {
  const { berTags } = Drupal;

  // Only the undo toasts, so hide() drops those and leaves any unrelated
  // toast on the stack alone. Both ways out of a toast go through drop().
  const open = new Set();

  const undoToast = {
    // opts: {message, seconds, onUndo, onExpire}. Returns {close}.
    open(opts) {
      let handle = null;
      const drop = (callback) => () => {
        open.delete(handle);
        if (callback) {
          callback();
        }
      };

      handle = berTags.toast.push({
        message: opts.message,
        seconds: Math.max(1, parseInt(opts.seconds, 10) || 10),
        countdown: true,
        actions: [{ label: Drupal.t('Undo'), onClick: drop(opts.onUndo) }],
        onExpire: drop(opts.onExpire),
      });
      open.add(handle);

      return handle;
    },
    hide() {
      const pending = Array.from(open);
      open.clear();
      pending.forEach((handle) => handle.close());
    },
  };

  berTags.undo = undoToast;
})(Drupal);
